export default __webpack_public_path__ + "static/SharpGroteskBook20-Regular-eb4b730b1b0efe643f64dc8f7b1d9c55.woff2";